module.exports = __webpack_public_path__ + "img/app-store-blue.dd0e73b6.png";